<template>
  <v-container fluid>
    <v-data-table :headers="headers" :items="items" :search="search">
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Parte Policial</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-text-field
            class="text-xs-center"
            v-model="search"
            append-icon="search"
            label="Busqueda"
            hide-details
            outlined
            dense
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark class="mb-2" @click="nuevaPartePolicial()"
            >Nuevo</v-btn
          >
        </v-toolbar>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-tooltip bottom color="primary">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="far far fa-edit"
              @click="verDetalles(item)"
              v-bind="attrs"
              v-on="on"
            >
            </v-icon>
          </template>
          <span>Editar</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <v-dialog max-width="600" persistent v-model="dialog">
      <v-card>
        <v-card-title class="primary white--text">Datos</v-card-title>
        <v-card-text>
          <v-container>
            <v-row justify="center">
              <v-col cols="8">
                <v-text-field
                  v-model="numeroAsistencia"
                  label="NUMERO DE ASISTENCIA"
                  @keyup.enter="BuscarNumeroAsistencia()"
                  hint="Presione enter para completar los campos."
                  persistent-hint
                  dense
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="aseguradora"
                  label="ASEGURADORA"
                  dense
                  outlined
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="placa"
                  label="PLACA"
                  dense
                  outlined
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-col cols="12" md="6">
                <v-select
                  v-model="gestion"
                  :items="itemsGestion"
                  label="GESTION"
                  dense
                  outlined
                  hide-details
                ></v-select>
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  v-model="estado"
                  :items="itemsEstado"
                  label="ESTADO"
                  dense
                  outlined
                  hide-details
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="5">
                <v-btn color="primary" @click="nuevoSeguimiento()"
                  >Agregar seguimiento</v-btn
                >
              </v-col>
              <v-col cols="12">
                <v-list dense v-if="itemsSeguimiento.length != 0">
                  <v-list-item v-for="(item, i) in itemsSeguimiento" :key="i">
                    <v-list-item-icon>
                      <v-icon small>fa-regular fa-circle</v-icon>
                    </v-list-item-icon>
                    <v-textarea
                      v-model="item.descripcion"
                      label="Seguimiento"
                      outlined
                      auto-grow
                      row-height="1"
                    >
                    </v-textarea>
                  </v-list-item>
                </v-list>
                <span v-else>No hay seguimientos</span>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions class="justify-end">
          <v-btn text @click="cerrarDialog()">Cerrar</v-btn>
          <v-btn
            class="primary"
            v-if="estadoNuevo == 1"
            @click="crearPartePolicial()"
            >Guardar</v-btn
          >
          <v-btn
            class="primary"
            v-if="estadoNuevo == 2"
            @click="actualizarPartePolicial()"
            >Actualizar</v-btn
          >
        </v-card-actions>
      </v-card>

      <!-- PreLoader -->
      <v-overlay v-model="overlay">
        <lottie-player
          autoplay
          loop
          mode="normal"
          src="https://assets5.lottiefiles.com/datafiles/XpFCWApEzLI29va/data.json"
          style="width: 320px"
        >
        </lottie-player>
      </v-overlay>
    </v-dialog>

    <v-dialog v-model="dialog_seguimiento" persistent width="500">
      <v-card>
        <v-card-title>Detalles</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-textarea
                v-model="seguimientos"
                label="SEGUIMIENTO"
                outlined
                hide-details
              >
              </v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="cerrarDialogSeguimiento()">Cancelar</v-btn>
          <v-btn
            color="primary"
            @click="crearSeguimientoPartePolicial()"
            v-if="estadoNuevo == 2"
            >Guardar</v-btn
          >
          <v-btn
            color="primary"
            @click="agregarSeguimientoPartePolicial()"
            v-if="estadoNuevo == 1"
            >Agregar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  data: () => ({
    search: "",
    headers: [
      { text: "Numero asistencia", value: "numeroAsistencia" },
      { text: "Aseguradora", value: "aseguradora" },
      { text: "Placa", value: "placa" },
      { text: "Gestión", value: "gestion" },
      { text: "Estado", value: "estado" },
      { text: "Opciones", value: "action", align: "center" },
    ],
    items: [],
    dialog: false,
    dialog_seguimiento: false,
    estadoNuevo: 1,
    overlay: false,
    idCabina: 0,
    id_parte_policial: 0,
    fecha_creacion: "",
    numeroAsistencia: "",
    aseguradora: "",
    placa: "",
    gestion: "",
    itemsGestion: [
      "AJUSTE DE PRESOPUESTO",
      "LEGAL-ADMINISTRATIVO",
      "CERRADO POR IND. ASEG",
      "DEPOSITO",
      "PAGADO POR MEDIO DE AR",
      "DEPOSITO A EXTERNOS",
      "SUBROGACION",
    ],
    estado: "",
    itemsEstado: ["FINALIZADO", "PROCESO"],
    seguimientos: "",
    itemsSeguimiento: [],
  }),
  created() {
    this.listar();
  },
  methods: {
    listar() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get("api/PartePoliciales/Listar", configuracion)
        .then((response) => {
          this.items = response.data;
        });
    },
    BuscarNumeroAsistencia() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get(
          "api/Cabinas/DetallexNumAsistencia/" + this.numeroAsistencia,
          configuracion
        )
        .then((response) => {
          this.idCabina = response.data[0].idCabina;
          this.aseguradora = response.data[0].cartera;
          this.placa = response.data[0].placa;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    nuevaPartePolicial() {
      this.estadoNuevo = 1;
      this.dialog = true;

      var today = new Date();
      this.fecha_creacion =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate() +
        " " +
        new Date().getHours() +
        ":" +
        new Date().getMinutes() +
        ":" +
        new Date().getSeconds();
    },
    crearPartePolicial() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .post(
          "api/PartePoliciales/Crear",
          {
            fecha_creacion: this.fecha_creacion,
            numeroAsistencia: this.aseguradora,
            aseguradora: this.aseguradora,
            estado: this.estado,
            gestion: this.gestion,
            placa: this.placa,
            seguimientos: this.itemsSeguimiento,
          },
          configuracion
        )
        .then(() => {
          this.cerrarDialog();
          this.listar();
        });
    },
    verDetalles(item) {
      this.id_parte_policial = item.id_parte_policial;
      this.fecha_creacion = item.fecha_creacion;
      this.numeroAsistencia = item.numeroAsistencia;
      this.aseguradora = item.aseguradora;
      this.gestion = item.gestion;
      this.placa = item.placa;
      this.estado = item.estado;

      this.listarSeguimientos();

      this.estadoNuevo = 2;
      this.dialog = true;
    },
    actualizarPartePolicial() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .put(
          "api/PartePoliciales/Actualizar",
          {
            id_parte_policial: this.id_parte_policial,
            fecha_creacion: this.fecha_creacion,
            numeroAsistencia: this.aseguradora,
            aseguradora: this.aseguradora,
            estado: this.estado,
            gestion: this.gestion,
            placa: this.placa,
          },
          configuracion
        )
        .then(() => {
          this.cerrarDialog();
          this.listar();
        });
    },
    cerrarDialog() {
      this.dialog = false;

      this.id_parte_policial = 0;
      this.fecha_creacion = "";
      this.numeroAsistencia = "";
      this.aseguradora = "";
      this.gestion = "";
      this.placa = "";
      this.estado = "";
      this.itemsSeguimiento = [];
    },
    listarSeguimientos() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get(
          "api/SeguimientoPartePoliciales/Listar/" + this.id_parte_policial,
          configuracion
        )
        .then((response) => {
          this.itemsSeguimiento = response.data;
        });
    },
    nuevoSeguimiento() {
      this.dialog_seguimiento = true;
    },
    agregarSeguimientoPartePolicial() {
      this.itemsSeguimiento.push({
        id_parte_policial: this.id_parte_policial,
        descripcion: this.seguimientos,
      });
      this.cerrarDialogSeguimiento();
    },
    crearSeguimientoPartePolicial() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .post(
          "api/SeguimientoPartePoliciales/Crear",
          {
            id_parte_policial: this.id_parte_policial,
            descripcion: this.seguimientos,
          },
          configuracion
        )
        .then(() => {
          this.cerrarDialogSeguimiento();
          this.listarSeguimientos();
        });
    },
    cerrarDialogSeguimiento() {
      this.dialog_seguimiento = false;

      this.seguimientos = "";
    },
  },
};
</script>